// src/contexts/LoadingContext.js
import React, { createContext, useContext, useState, useCallback } from 'react';

const LoadingContext = createContext({ isLoading: false, increment: () => {}, decrement: () => {} });

export const LoadingProvider = ({ children }) => {
    const [count, setCount] = useState(0);

    const increment = useCallback(() => setCount(c => c + 1), []);
    const decrement = useCallback(() => setCount(c => Math.max(0, c - 1)), []);

    return (
        <LoadingContext.Provider value={{ isLoading: count > 0, increment, decrement }}>
            {children}
        </LoadingContext.Provider>
    );
};

export const useLoading = () => useContext(LoadingContext);
